import React, {Component} from "react";
import {connect} from "react-redux";
import LoadingComponent from "../components/LoadingComponent";
import '../style/history.css';
import TitleZoneComponent from "../components/TitleZoneComponent";
import FormMessageComponent from "../components/FormMessageComponent";
import TranslatedTextComponent from "../components/TranslatedTextComponent";
import FormComponent from "../components/FormComponent";

class FormPage extends Component {

    componentDidMount() {
        this.props.formPageMounted();
    }

    componentDidUpdate(prevProps) {
        if (this.props.lang !== prevProps.lang)
            this.props.formPageMounted();
    }

    render() {
        let cardContent = <LoadingComponent/>;
        let title;
        if (!this.props.loading) {
            if (this.props.found) {
                title = <span>{this.props.formTemplate.title}</span>;
                if (this.props.submitSuccess) {
                    cardContent = <FormMessageComponent messageKey="form.success"/>
                } else if (this.props.formTemplate.alreadySubmitted) {
                    cardContent = <FormMessageComponent messageKey="form.alreadySubmitted"/>
                } else {
                    cardContent = <FormComponent formTemplate={this.props.formTemplate}
                                                 onSubmitFormData={(formData) => this.props.submitFormData(formData, this.props.lang)}
                                                 submitting={this.props.submitting}
                                                 missingFields={this.props.missingFields}
                                                 lang={this.props.lang}
                                                 invalidPhoneNumber={this.props.invalidPhoneNumber}
                                                 invalidEmailAddress={this.props.invalidEmailAddress}/>;
                }
            } else {
                title = <TranslatedTextComponent textKey={'form.notFound.title'}/>
                cardContent = <FormMessageComponent messageKey="form.notFound.description"/>;
            }
        }

        return (
            <div className="full-centered-content form-content">
                <TitleZoneComponent
                    title={title}
                    showProgramTitle={false}
                    showIcon={false}/>
                <div className="form-card">
                    {cardContent}
                </div>
            </div>
        );
    }
}

export default connect(
    (state) => {
        return {
            formTemplate: state.formTemplate.item,
            loading: state.formTemplate.loading,
            found: state.formTemplate.found,
            submitting: state.formTemplate.submitting,
            missingFields: state.formTemplate.missingFields,
            lang: state.language.currentLanguage,
            submitSuccess: state.formTemplate.submitSuccess,
            invalidPhoneNumber: state.formTemplate.invalidPhoneNumber,
            invalidEmailAddress: state.formTemplate.invalidEmailAddress
        };
    },
    (dispatch, ownProps) => {
        return {
            formPageMounted: () => {
                dispatch({
                    type: 'FETCH_FORM_TEMPLATE',
                    friendlyName: ownProps.match.params.formFriendlyName
                });
            },
            submitFormData: (formData, lang) => {
                formData.language = lang;
                dispatch({
                    type: 'SUBMIT_FORM_DATA',
                    friendlyName: ownProps.match.params.formFriendlyName,
                    formData
                })
            }
        }
    }
)(FormPage)